import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  allRightReservedLabel: {
    id: 'course-authoring.schedule-section.license.all-right-reserved.label',
    defaultMessage: 'All rights reserved',
  },
  creativeCommonsReservedLabel: {
    id: 'course-authoring.schedule-section.license.creative-commons.label',
    defaultMessage: 'Some rights reserved',
  },
});

export default messages;
